export const CScreateConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      title
      image {
        alt
        identityId
        key
        level
      }
      messages {
        items {
          attachments {
            identityId
            key
            level
            type
          }
          conversationId
          text
          createdBy
          createdAt
          updatedAt
          id
          conversationMessagesId
          users
          readBy
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          user {
            identityId
            about
            firstName
            lastName
            profileImg {
              alt
              identityId
              key
              level
            }
            country
            interests
            facebook
            instagram
            twitter
            linkedin
            locale
            createdAt
            updatedAt
            id
            owner
          }
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
        }
        tags
        country
        status
        owner
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdAt
      updatedAt
      id
    }
  }
`;

export const CScreateUserConversation = /* GraphQL */ `
  mutation CreateUserConversation(
    $input: CreateUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    createUserConversation(input: $input, condition: $condition) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
        }
        messages {
          items {
            attachments {
              identityId
              key
              level
              type
            }
            conversationId
            text
            createdBy
            createdAt
            updatedAt
            id
            conversationMessagesId
            users
            readBy
          }
          nextToken
        }
        userConversations {
          items {
            conversationId
            userId
            user {
              identityId
              about
              firstName
              lastName
              country
              profileImg {
                alt
                identityId
                key
                level
              }
              interests
              facebook
              instagram
              twitter
              linkedin
              createdAt
              updatedAt
              id
              owner
            }
            users
            createdAt
            updatedAt
            id
            conversationUserConversationsId
          }
          nextToken
        }
        productId
        product {
          title
          category
          description
          images {
            alt
            identityId
            key
            level
          }
          tags
          country
          status
          owner
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        identityId
        about
        firstName
        lastName
        country
        profileImg {
          alt
          identityId
          key
          level
        }
        interests
        facebook
        instagram
        twitter
        linkedin
        locale
        createdAt
        updatedAt
        id
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;

export const CScreateTeamUserItem = /* GraphQL */ `
  mutation CreateTeamUserItem($input: CreateTeamUserInput) {
    createTeamUserItem(input: $input) {
      teamId
      team {
        title
        teamUsers {
          nextToken
        }
        createdAt
        updatedAt
        id
        owner
      }
      userId
      user {
        id
        identityId
        about
        firstName
        lastName
        country
        profileImg {
          alt
          identityId
          key
          level
        }
        interests
        facebook
        instagram
        twitter
        linkedin
        locale
        onboardingStatus
        teamId
        team {
          title
          createdAt
          updatedAt
          id
          owner
        }
        userType
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      id
      teamTeamUsersId
      owners
    }
  }
`;

export const CSdeleteTeamUser = /* GraphQL */ `
  mutation DeleteTeamUser(
    $input: DeleteTeamUserInput!
    $condition: ModelTeamUserConditionInput
  ) {
    deleteTeamUser(input: $input, condition: $condition) {
      teamId
      team {
        title
        teamUsers {
          nextToken
        }
        createdAt
        updatedAt
        id
        owner
      }
      userId
      user {
        identityId
        about
        firstName
        lastName
        country
        profileImg {
          alt
          identityId
          key
          level
        }
        interests
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          status
          paymentProvider
          expiresAt
          createdAt
          updatedAt
          id
          owner
        }
        teamId
        team {
          title
          createdAt
          updatedAt
          id
          owner
        }
        createdAt
        updatedAt
        id
        owner
      }
      createdAt
      updatedAt
      id
      teamTeamUsersId
      owners
    }
  }
`;

export const CSDeleteAccount = /* GraphQL */ `
  mutation DeleteAccount {
    deleteAccount {
      identityId
      about
      firstName
      lastName
      country
      profileImg {
        alt
        identityId
        key
        level
      }
      interests
      locations
      facebook
      instagram
      twitter
      linkedin
      locale
      onboardingStatus
      userType
      createdAt
      updatedAt
      owner
    }
  }
`;

export const CSdeleteUserConversation = /* GraphQL */ `
  mutation DeleteUserConversation(
    $input: DeleteUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    deleteUserConversation(input: $input, condition: $condition) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
        }
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          country
          status
          owner
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        about
        firstName
        lastName
        country
        profileImg {
          alt
          identityId
          key
          level
        }
        interests
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        onboardingStatus
        teamId
        team {
          title
          createdAt
          updatedAt
          id
          owner
        }
        userType
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
